<template lang="pug">
.cp-partner
  .w
    .partner-title
      span 合作伙伴认证
    .partner-content
      .row.row1
        img(v-for="v in row1", :src="v",)
      .row.row2
        img(v-for="v in row2", :src="v")
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      row1: [
        require('@/assets/tengxun.png'),
        require('@/assets/aliyun.png'),
        require('@/assets/baidu.png'),
        require('@/assets/zhongan.png'),
        require('@/assets/logo360.png'),
        require('@/assets/zhongxin.png'),
        require('@/assets/damoyuan.png'),
      ],
      row2: [
        require('@/assets/qinghuakeji.png'),
        require('@/assets/hongkong.png'),
        require('@/assets/university1.png'),
        require('@/assets/wuhandaxues.png'),
        require('@/assets/jiaoda.png'),
        require('@/assets/huazhongda.png'),
        require('@/assets/university2.png'),
      ],
    }
  },
  computed: {},
  methods: {}
}
</script>
<style lang="stylus">
.cp-partner
  .partner-title
    height 53px
    margin-bottom 57px
    display flex
    justify-content center
    align-items center
    background url('../../../assets/maisui.png') center / 214px no-repeat
    span
      position relative
      top 2px
      font-size 24px
    &::before
      margin-right 45px
      content ''
      display block
      width 200px
      height 1px
      background #fff
      opacity 0.4
    &::after
      margin-left 45px
      content ''
      display block
      width 200px
      height 1px
      background #fff
      opacity 0.4
  .partner-content
    .row
      display flex
      justify-content space-between
      align-items center
    .row1
      padding 0px 28px
      img
        &:nth-child(1)
          width 120px
        &:nth-child(2)
          width 112px
        &:nth-child(3)
          width 102px
        &:nth-child(4)
          width 108px
        &:nth-child(5)
          width 103px
        &:nth-child(6)
          width 94px
        &:nth-child(7)
          width 83px
    .row2
      margin-top 38px
      padding 0 90px
      img
        &:nth-child(1)
          width 110px
        &:nth-child(2)
          width 120px
        &:nth-child(3)
          width 37px
        &:nth-child(4)
          width 54px
        &:nth-child(5)
          width 54px
        &:nth-child(6)
          width 61px
        &:nth-child(7)
          width 52px
</style>
